import { RouteType } from "../../types/RouteType";
import crmDashboardRoute from "./Dashboard/CrmDashboard.Route";
import accountsListRoute from "./Accounts/AccountsList/AccountsList.Route";
import accountDashboardRoute from "./Accounts/AccountDashboard/AccountDashboard.Route";
import contactsListRoute from "./Contacts/ContactsList.Route";
import clientListRoute from "./ClientList/clientList.Route";

// import opportunitiesListRoute from "./Opportunities/OpportunitiesList.Route";

import bidsListRoute from "./Bids/BidsList.Route";
import projectsListRoute from "./Projects/ProjectsList.Route";
import projectDetailsRoute from "./Projects/ProjectDetails/ProjectDetails.Route";
// import productionOrdersListRoute from "./ProductionOrders/ProductionOrdersList.Route";
import jobPanelManagementRoute from "./JobPanelManagement/JobPanelManagement.Route";
import panelDesignCenterRoute from "./PanelDesignCenter/PanelDesignCenter.Route";

// TODO: Import route definitions from each module as they are created
// ... etc

const crmRoutesList: RouteType[] = [
  // Dashboard
  crmDashboardRoute,

  // Accounts
  accountsListRoute,
  accountDashboardRoute,

  // Contacts
  contactsListRoute,

  // Client List
  ...clientListRoute,

  // Opportunities
  // opportunitiesListRoute,
  // salesPipelineRoute,

  // Bids
  bidsListRoute,
  // bidAnalyticsRoute,

  // Projects
  projectsListRoute,
  projectDetailsRoute,
  // projectDetailRoute,
  // projectFormRoute,
  // projectDashboardRoute,

  // Production Orders
  // productionOrdersListRoute,

  // Job Panel Management
  jobPanelManagementRoute,

  // Panel Design Center
  panelDesignCenterRoute,

  // Activities
  // activitiesListRoute,
  // activityDetailRoute,
  // activityFormRoute,
  // activityCalendarRoute,

  // Analytics
  // opportunityAnalyticsRoute,
  // crmReportsRoute,
];

export default crmRoutesList;
